import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-636fa042")

_pushScopeId("data-v-636fa042")
const _hoisted_1 = /*#__PURE__*/_createVNode("i", { class: "fa fa-camera" }, null, -1)
const _hoisted_2 = { class: "p-m-2" }
const _hoisted_3 = {
  key: 0,
  class: "pi pi-exclamation-triangle kn-warning-icon",
  "data-test": "warning-icon"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "p-d-flex p-flex-row" }
const _hoisted_6 = {
  id: "snapshot-name-container",
  class: "p-m-2"
}
const _hoisted_7 = { class: "kn-material-input-label" }
const _hoisted_8 = { class: "p-d-flex p-flex-row p-jc-between" }
const _hoisted_9 = { class: "name-help p-m-0" }
const _hoisted_10 = { class: "p-m-2" }
const _hoisted_11 = { class: "kn-material-input-label" }
const _hoisted_12 = { class: "p-m-2" }
const _hoisted_13 = { class: "kn-material-input-label" }
const _hoisted_14 = { class: "p-d-flex p-jc-end" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputText = _resolveComponent("InputText")
  const _component_AccordionTab = _resolveComponent("AccordionTab")
  const _component_Accordion = _resolveComponent("Accordion")

  return (_openBlock(), _createBlock(_component_Accordion, { activeIndex: 0 }, {
    default: _withId(() => [
      _createVNode(_component_AccordionTab, null, {
        header: _withId(() => [
          _hoisted_1,
          _createVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('managers.scheduler.saveAsSnapshot')), 1),
          (_ctx.document.invalid?.invalidSnapshot)
            ? (_openBlock(), _createBlock("i", _hoisted_3))
            : _createCommentVNode("", true)
        ]),
        default: _withId(() => [
          (_ctx.document)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _createVNode("div", _hoisted_6, [
                    _createVNode("span", null, [
                      _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('common.name')) + " *", 1),
                      _createVNode(_component_InputText, {
                        class: ["kn-material-input", {
                                    'p-invalid': _ctx.snapshotNameDirty && (!_ctx.document.snapshotname || _ctx.document.snapshotname.length === 0)
                                }],
                        modelValue: _ctx.document.snapshotname,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.document.snapshotname = $event)),
                        maxLength: _ctx.schedulerTimingOutputOutputTabDescriptor.accordion.snapshot.nameMaxLength,
                        onInput: _ctx.setNameValidation,
                        onBlur: _ctx.setNameValidation
                      }, null, 8, ["modelValue", "class", "maxLength", "onInput", "onBlur"])
                    ]),
                    _createVNode("div", _hoisted_8, [
                      _createVNode("div", null, [
                        _withDirectives(_createVNode("div", { class: "p-error p-grid p-m-2" }, _toDisplayString(_ctx.$t('common.validation.required', { fieldName: _ctx.$t('common.name') })), 513), [
                          [_vShow, _ctx.snapshotNameDirty && (!_ctx.document.snapshotname || _ctx.document.snapshotname.length === 0)]
                        ])
                      ]),
                      _createVNode("p", _hoisted_9, _toDisplayString(_ctx.nameHelp), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_10, [
                    _createVNode("span", null, [
                      _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('managers.scheduler.historyLength')), 1),
                      _createVNode(_component_InputText, {
                        class: "kn-material-input",
                        type: "number",
                        modelValue: _ctx.document.snapshothistorylength,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.document.snapshothistorylength = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode("span", null, [
                    _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('common.description')), 1),
                    _createVNode(_component_InputText, {
                      class: "kn-material-input",
                      modelValue: _ctx.document.snapshotdescription,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.document.snapshotdescription = $event)),
                      maxLength: _ctx.schedulerTimingOutputOutputTabDescriptor.accordion.snapshot.descriptionMaxLength
                    }, null, 8, ["modelValue", "maxLength"])
                  ]),
                  _createVNode("div", _hoisted_14, [
                    _createVNode("small", null, _toDisplayString(_ctx.descriptionHelp), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})